export default __webpack_public_path__ + "e7099c7b1771a8e836dff84720564827.svg";